/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { ConnectInstrumentation, ANONYMOUS_NAME } from './instrumentation';
export {
  AttributeNames,
  ConnectNames,
  ConnectTypes,
} from './enums/AttributeNames';
